/* JULALA cart drawer + AJAX add (2026-10). Loaded deferred; no framework.
   window.julalaCart.add(items, {open}) is used by the PDP, cards and "Passt zu deinem Stein". */
(function () {
  'use strict';
  var drawer = document.querySelector('[data-jcd]');
  var SECTION = 'julala-cart-drawer';
  var lastFocus = null;

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function toast(msg) {
    var t = document.getElementById('jcd-toast');
    if (!t) {
      t = document.createElement('div'); t.id = 'jcd-toast'; t.setAttribute('role', 'status');
      t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:1100;background:#2A2320;color:#FDFBF8;padding:10px 16px;border-radius:999px;font:14px/1.4 "Instrument Sans",sans-serif;max-width:90vw;text-align:center';
      document.body.appendChild(t);
    }
    t.textContent = msg; t.hidden = false; clearTimeout(t._h); t._h = setTimeout(function () { t.hidden = true; }, 3200);
  }

  function open() {
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var c = drawer.querySelector('.jcd__close'); if (c) c.focus({ preventScroll: true });
    return true;
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) { lastFocus.focus({ preventScroll: true }); lastFocus = null; }
  }

  function setCount(n) {
    $$('.julala-hd__cart').forEach(function (a) {
      var c = a.querySelector('.julala-hd__count');
      if (!c) { c = document.createElement('span'); c.className = 'julala-hd__count'; c.setAttribute('aria-hidden', 'true'); a.appendChild(c); }
      c.textContent = n; c.hidden = n === 0;
      a.setAttribute('aria-label', n > 0 ? 'Warenkorb, ' + n + ' Artikel' : 'Warenkorb');
    });
  }

  function json(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function refresh(openAfter) {
    if (drawer) drawer.classList.add('is-busy');
    return fetch('/?sections=' + SECTION).then(function (r) { return r.json(); }).then(function (s) {
      if (drawer && s[SECTION]) {
        var tmp = document.createElement('div'); tmp.innerHTML = s[SECTION];
        var fresh = tmp.querySelector('.jcd__panel'), cur = drawer.querySelector('.jcd__panel');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      }
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      setCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('julala:cart', { detail: cart }));
      if (drawer) drawer.classList.remove('is-busy');
      if (openAfter && !open()) location.href = '/cart';
      return cart;
    }).catch(function () { if (drawer) drawer.classList.remove('is-busy'); });
  }

  function add(items, opts) {
    opts = opts || {};
    return json('/cart/add.js', { items: items }).then(function () {
      return refresh(opts.open !== false);
    }).catch(function (err) {
      toast((err && (err.description || err.message)) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.');
      throw err;
    });
  }

  window.julalaCart = { add: add, open: open, close: close, refresh: refresh, enabled: !!drawer };

  if (!drawer) return; // drawer switched off: the theme keeps the classic /cart page flow

  // Header cart icon opens the drawer
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.julala-hd__cart');
    if (a && !e.metaKey && !e.ctrlKey) { e.preventDefault(); open(); refresh(false); return; }
    if (e.target.closest('[data-jcd-close]')) { close(); return; }
    var q = e.target.closest('[data-jcd-qty]');
    if (q) {
      q.disabled = true;
      json('/cart/change.js', { id: q.getAttribute('data-key'), quantity: +q.getAttribute('data-jcd-qty') })
        .then(function () { return refresh(false); })
        .catch(function () { toast('Die Menge konnte nicht geändert werden.'); q.disabled = false; });
      return;
    }
    var ad = e.target.closest('[data-jcd-add]');
    if (ad) { ad.disabled = true; add([{ id: +ad.getAttribute('data-jcd-add'), quantity: 1 }]).catch(function () { ad.disabled = false; }); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

  var noteT;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-jcd-note]')) return;
    clearTimeout(noteT); var v = e.target.value;
    noteT = setTimeout(function () { json('/cart/update.js', { note: v }).catch(function () {}); }, 500);
  });

  // Product forms (PDP + quick add): add without leaving the page; optional same-stone add-on
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-julala-ajax]')) return;
    e.preventDefault();
    var fd = new FormData(form);
    var id = +fd.get('id'); if (!id) return;
    var item = { id: id, quantity: +(fd.get('quantity') || 1) };
    var props = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v !== '') props[m[1]] = v; });
    if (Object.keys(props).length) item.properties = props;
    var items = [item];
    var addon = form.querySelector('[data-addon]:checked');
    if (addon && addon.value) items.push({ id: +addon.value, quantity: 1 });
    var btns = $$('[data-pdp-buy], button[type="submit"]', form).concat($$('button[form="' + form.id + '"]'));
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    add(items).catch(function () {}).then(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
  });

  // Quick add sheet (cards "+"): stone picker loaded from the product page
  var sheet;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    var single = b.getAttribute('data-variant');
    if (single) { b.disabled = true; add([{ id: +single, quantity: 1 }]).catch(function () {}).then(function () { b.disabled = false; }); return; }
    if (!sheet) {
      sheet = document.createElement('dialog'); sheet.className = 'jqs';
      sheet.innerHTML = '<div class="jqs__head"><span>Stein wählen</span><button type="button" class="jcd__close" data-jqs-close aria-label="Schließen"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div><div class="jqs__body"></div>';
      document.body.appendChild(sheet);
      sheet.addEventListener('click', function (ev) {
        if (ev.target === sheet || ev.target.closest('[data-jqs-close]')) sheet.close();
        var go = ev.target.closest('[data-jqs-add]');
        if (go) {
          var sel = sheet.querySelector('input[name="jqs-v"]:checked'); if (!sel) return;
          go.disabled = true;
          add([{ id: +sel.value, quantity: 1 }]).then(function () { sheet.close(); }).catch(function () {}).then(function () { go.disabled = false; });
        }
      });
      sheet.addEventListener('change', function (ev) {
        if (!ev.target.matches('input[name="jqs-v"]')) return;
        var img = sheet.querySelector('[data-jqs-img]'), src = ev.target.getAttribute('data-img');
        if (img) { if (src) { img.src = src; img.hidden = false; } else { img.hidden = true; } }
        var p = sheet.querySelector('[data-jqs-price]'); if (p) p.textContent = ev.target.getAttribute('data-price');
      });
    }
    var body = sheet.querySelector('.jqs__body');
    body.innerHTML = '<p style="margin:0;color:#5E534A">Lädt …</p>';
    if (sheet.showModal) sheet.showModal(); else sheet.setAttribute('open', '');
    var url = b.getAttribute('data-quick-add');
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=julala-quick').then(function (r) { return r.text(); }).then(function (html) {
      var t = document.createElement('div'); t.innerHTML = html;
      var inner = t.querySelector('[data-jqs-inner]');
      body.innerHTML = ''; if (inner) body.appendChild(inner); else location.href = url;
    }).catch(function () { location.href = url; });
  });
})();
